import { IApplicationState } from '../../../../types/types';
import { EFeature } from '../../../../types/rest/IUserMeta';
import { getAuthUser } from './getAuthUser';
import { getController } from 'app/store/constants';

export const isNewFeatureForUser = (
    state: IApplicationState,
    feature: EFeature
): boolean => {
    if (getController().demo) return null;

    const { meta } = getAuthUser(state);
    const featuresSeen = meta && meta.featuresSeen;
    return !featuresSeen || !featuresSeen.includes(feature);
};
